module.exports = __webpack_public_path__ + "static/media/strategy 1.5ebd6544.svg";